var FF = FF || {};

FF.mq = {
    queries: [],
    current: "",
    initialized : false,
    init: function () {
        var that = this;

        /*
        * Nesting request animation frame
        * as per: https://medium.com/@paul_irish/requestanimationframe-scheduling-for-nerds-9c57f7438ef4
        * */
        requestAnimationFrame(function () {
            requestAnimationFrame(function () {
                that._queries().forEach(function (q) {
                    that.queries.push(q);
                });
                that.current = that._current();
            });
        });

        this.watcher();
    },

    /**
     * Retrieve all available queries
     * @returns {Array}
     */
    _queries: function () {
        var style = window.getComputedStyle(document.body, "::after"),
            content = style.getPropertyValue("content").replace(/['"]+/g, ""),
            mediaQueries = [];

        content.split("&").forEach(function(mq) {
            var mqParts = mq.split(":");

            mediaQueries.push({
                name: mqParts[0],
                rawValue: mqParts[1],
                value: "(min-width: " + mqParts[1] + ")"
            });
        });

        return mediaQueries;
    },

    /**
     * Get the current active breakpoint
     * @returns {string}
     */
    _current: function () {
        var matched;

        this.queries.forEach(function(query) {
            if (window.matchMedia(query.value).matches) {
                matched = query;
            }
        });

        if (matched && matched.name) {
            return matched.name;
        }

        return "";
    },

    /**
     * Get a breakpoint by name
     * @param {string} name - Name of the breakpoint
     * @returns {string}
     */
    get: function (name) {
        var matches = this.queries.filter(function(query) {
            return query.name === name;
        });

        if (matches && matches.length > 0) {
            return matches[0].value;
        }
    },

    /**
     * Get a breakpoint value by name
     * @param {string} name - Name of the breakpoint
     * @returns {string}
     */
    getValue: function(name) {
        var matches = this.queries.filter(function(query) {
            return query.name === name;
        });

        if (matches && matches.length > 0) {
            return matches[0].rawValue;
        }
    },

    /**
     * Check if given breakpoint is matched
     * @param {string} name - Name of the breakpoint
     * @returns {boolean}
     */
    atLeast: function (name) {
        var query = this.get(name);

        if (query) {
            return window.matchMedia(query).matches;
        }

        return false;
    },

    /**
     * Watches changes in the viewport and update current breakpoint on resize
     */
    watcher: function () {
        var that = this;

        window.addEventListener("resize", function() {
            var newSize = that._current(),
                oldSize = this.current;

            if (that.current !== newSize) {
                that.current = newSize;

                var event = new CustomEvent("FF-resize", {
                    detail: {
                        oldSize: oldSize,
                        newSize: newSize
                    }
                });

                window.dispatchEvent(event);
            }
        });
    }
}

FF.mq.init();